//////////////////////////////////////////////////////   
//                                                  //   
//  PARA TODOS OS USUÁRIOS:                         //   
//                                                  //   
//  APARECE COMO BOTÃO DE VOLTAR NO                 //   
//  HEADER DAS PÁGINAS QUE NÃO SÃO A HOME           //   
//                                                  //   
//  FUNCIONALIDADE: VOLTAR PARA A PÁGINA HOME       // 
//                                                  //   
//////////////////////////////////////////////////////   



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/components/continuar_comprando.js                  //
//      frontend/src/components/franqueado.js                           //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


import '../../assets/css/local/header.css';


function Voltar() {
    async function to_home(){  // FUNÇÃO PARA REDIRECIONAR PARA A HOME
        // FUNÇÃO CHAMADA NO CLICK DO BOTÃO 'Produtos' DESTE COMPONENTE

        var id_loja = sessionStorage['loja']
        window.location.href = '/?id='+ id_loja  // REDIRECIONA PARA A HOME
    }

    return (
        <div className="w-100 header-size">
            <div className="busca col-12 row mx-0 my-1">
                <button class='w-100 btn-pretobranco montserrat negrito' onClick={to_home}>
                    <i class='fa fa-arrow-circle-left pr-4'></i>
                    Produtos
                </button>
            </div>
        </div>
    );
  }

  export default Voltar;
  